import { useState } from 'react';
import type { PaymentResult } from '@/features/subscription/types/subscriptionStep';
import { safeHttpUrl } from '@/utils/safeUrl';

interface ResultStepProps {
  result: PaymentResult;
  onClose: () => void;
}

export function ResultStep({ result, onClose }: ResultStepProps) {
  const [pixCopied, setPixCopied] = useState(false);

  const handleCopyPix = () => {
    if (!result.brCode) return;
    navigator.clipboard.writeText(result.brCode).then(() => {
      setPixCopied(true);
      setTimeout(() => setPixCopied(false), 2000);
    });
  };

  // Guard against `javascript:` / `data:` URIs (XSS-VULN-02 — reflected
  // payload from subscribeToPlan.paymentLinkUrl reaches this href sink
  // unsanitized).
  const safeLink = safeHttpUrl(result.paymentLinkUrl);

  return (
    <div className="flex flex-col items-center gap-6 py-8 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-success-50">
        <svg viewBox="0 0 24 24" className="h-8 w-8 text-success-600" fill="none" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <div>
        <p className="font-display text-xl font-bold text-slate-900">
          {result.isAutoCharged ? 'Assinatura ativada!' : 'Assinatura criada!'}
        </p>
        <p className="mt-1 text-sm text-slate-500">
          {result.isAutoCharged
            ? `Plano ${result.planName} — pagamento debitado no cartão.`
            : `Plano ${result.planName} — efetue o pagamento para ativar.`}
        </p>
      </div>
      <div className="flex w-full max-w-sm flex-col gap-3">
        {result.brCode && (
          <button
            type="button"
            onClick={handleCopyPix}
            className="button w-full justify-center"
          >
            {pixCopied ? 'Código copiado!' : 'Copiar código PIX'}
          </button>
        )}
        {safeLink && (
          <a
            href={safeLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-6 py-3 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
          >
            Abrir link de pagamento
          </a>
        )}
        <button type="button" onClick={onClose} className="button w-full justify-center">
          Fechar
        </button>
      </div>
    </div>
  );
}
